import React from "react";
import { Form, Button, Select, DatePicker } from 'antd';
import icons from "Common/Icons";
import utils from "utils";
import dayjs from "dayjs";
import { CONSTANTS } from "utils/constant";

const popupStyle = {
    zIndex: 999999
}

export default class extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data || {},
            disabler: false,
            errorMsgFlagstate: false,
        }

        this.form = React.createRef()
        this.applyBtn = React.createRef()
    }

    componentDidMount() {
        this.form.current.setFieldsValue(this.state.data);
        this.applyBtn.current.disabled = false;
    }


    handleSubmit(values) {
        let data = values[this.props.name];
        if (!this.addAvailabilityList(data)) {
            data = data.map(m => {
                return {
                    [this.props.from]: `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${utils.FormatDate(m[this.props.from], "TIME_1")}`,
                    [this.props.to]: `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${utils.FormatDate(m[this.props.to], "TIME_1")}`,
                }
            })
        }
        if (this.props.name == "doctor_holiday") {
            data = data.map(m => {
                return {
                    [this.props.from]: `${utils.FormatDate(m[this.props.from], "DATE_12")} 00:00:00`,
                    [this.props.to]: `${utils.FormatDate(m[this.props.to], "DATE_12")} 23:59:59`,
                }
            })
        }
        if(this.props.name == "doctor_availability"){
            data = data.map(m => {
                return {
                    day_of_week: m.day,
                    [this.props.from]: `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${utils.FormatDate(m[this.props.from], "TIME_SEC_1")}`,
                    [this.props.to]: `${utils.FormatDate(utils.TimezoneOffsetConversion(), "DATE_12")} ${utils.FormatDate(m[this.props.to], "TIME_SEC_1")}`,
                }
            })
        }
        if (this.state.errorMsgFlagstate == false) typeof this.props.handleFunction == "function" && this.props.handleFunction(this.props.name, { [this.props.name]: data });
    };


    convertToDateObject(array2) {
        let datearray = array2.map((ele) => {
            if (ele != "undefined/NaN/undefined") {
                var dateParts = ele.split("/");
                // month is 0-based, that's why we need dataParts[1] - 1
                var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
                return dateObject
            }

        })
        return datearray

    }


    addAvailabilityList(data, add) {
        let tempKeys = { [this.props.from]: null, [this.props.to]: null };
        if (this.props.name == "doctor_availability") tempKeys["day_of_week"] = null;
        let errorMsgFlag = false;
        let duplicateFlag = true;
        let errorMsg = null,
            list = data;
        let obj = Object.assign(tempKeys, list && list.length > 0 && list[list.length - 1] || {});
        // errorMsgFlag = Object.keys(obj).every(m => obj[m] ? true : false);
        if((obj["day"] && obj["start_time"] && obj["end_time"]) || (this.props.name =="doctor_holiday" && obj["end_day"] && obj["start_day"]))
        {
            errorMsgFlag = true;
        }
        else{ errorMsgFlag = false;}
        let tempFlag = (list || []).every(m => {
            if (m !== undefined) {
                if (this.props.name == "doctor_availability" && dayjs(m[this.props.to]).isAfter(m[this.props.from])) return true;
                else if (this.props.name == "doctor_holiday" && (dayjs(m[this.props.to]).isSame(m[this.props.from]) || dayjs(m[this.props.to]).isAfter(m[this.props.from]))) return true;

            }
            else errorMsgFlag = false;
        })

        if (this.props.name == "doctor_availability" && list.length > 1) {
            list.find((element, index) => {
                list.forEach((value, position) => {
                    if (index !== position && element?.day === value?.day
                        && ((element?.start_time >= value?.start_time && element?.start_time < value?.end_time)
                            || (element?.end_time > value?.start_time && element?.end_time <= value?.end_time))
                    ) {
                        duplicateFlag = false;
                    }
                })
            })
        }
        if (this.props.name == "doctor_holiday" && list.length > 1) {
            let entry = list[list.length - 1]
            let array1 = []
            let startEndDtArray = []

            list.forEach((value) => {

                let start_month = value?.start_day?.month()
                start_month = start_month + 1
                let end_month = value?.end_day?.month()
                end_month = end_month + 1
                let end = value?.end_day?.date().toString() + "/" + end_month?.toString() + "/" + value?.end_day?.year().toString()
                let start = value?.start_day?.date().toString() + "/" + start_month?.toString() + "/" + value?.start_day?.year().toString()


                if (start) {
                    array1.push(start)
                    startEndDtArray.push(start)
                    // array3.push(value?.start_day?.date()+value?.start_day?.month()+value?.start_day?.year())
                }

                if (start !== end && end) {
                    array1.push(end)
                }

                if (end) {
                    startEndDtArray.push(end)
                }

            })

            if (new Set(array1).size !== array1.length) {
                duplicateFlag = false;
            }
            // let array2 = Array.from(new Set(array1))
            let array2 = startEndDtArray
            let setArray = this.convertToDateObject(array2);
            let setArray2 = setArray
            setArray = setArray.filter(datevalue => datevalue != undefined)

            for (let i = 0; i < setArray.length; i += 2) {
                let datevalue = setArray[i];
                for (let j = 0; j < setArray2.length; j += 2) {
                    if ((datevalue && setArray2[j] && setArray2[j + 1]) !== undefined && datevalue > setArray2[j] && datevalue < setArray2[j + 1]) {
                        duplicateFlag = false;
                        break;
                    }
                }
            }
        }

        if (list == undefined || list.length == 0) {
            add && add();
        }
        if (!errorMsgFlag) {
            errorMsg = "Please fill all the fields opened!";
            this.setState({ errorMsgFlagstate: true })
        }
        else {
            if (tempFlag && duplicateFlag) {
                add && add();
                this.applyBtn.current.disabled = false;
                this.setState({disabler:false,errorMsgFlagstate:false})
            }
            else {
                this.props.name == "doctor_availability" ? errorMsg = "Invalid time selection" : errorMsg = "Invalid date selection";
                this.applyBtn.current.disabled = true;
                this.setState({ disabler: true })
            }
        }
        if (!duplicateFlag) {
            this.applyBtn.current.disabled = true;
            this.setState({ disabler: true })
            errorMsg = "Duplicates are not allowed"
        }
        if (list.length == 0 && add == undefined) {
            //if (list.length == 0) {
            errorMsg = null;
            this.applyBtn.current.disabled = false;
            this.setState({disabler:false,errorMsgFlagstate:false})

        }
        this.setState({
            errorMsg: errorMsg,
        });
        return true;
    }



    getCustomTimeSlots() {
        let tempArray = [], stepBy = 0;
        for (let i = 0; i < 24; i++) {
            if (i >= 0 && i < 24) { // temperory time restriction
                if (stepBy) {
                    for (let j = 0; j <= 60; j++) {
                        if (j % stepBy == 0 && j != 60) {
                            tempArray.push(`${i > 9 ? i : ("0" + i)}:${j > 9 ? j : ('0' + j)}`)
                        }
                    }
                } else {
                    tempArray.push(`${i > 9 ? i : ("0" + i)}:00`)
                    for (let j = 0; j <= 60; j++) {
                        if (i == 23 && j == 59) {
                            tempArray.push(`${i}:${j}`)
                        }
                    }
                }
            }

        }
        return tempArray.map(m => {
            let date = `${utils.FormatDate(dayjs(), "DATE_12")} ${m}`
            return {
                value: date,
                label: (m == "00:00" ? m + " AM" : m == "23:59" ? "12:00 AM" : utils.FormatDate(date, "TIME_1"))
            }
        });;
    }


    generateDropDown(config, key) {
        let { placeholder = null, data = [] } = config
        return (
            this.props.name != "doctor_holiday" ? <Select style={{ width: "125px" }}
                showSearch
                placeholder={placeholder}
                size="small"
                options={data}
                optionFilterProp="children"
                dropdownStyle={popupStyle}
                filterOption={(input, option) => option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                onChange={val => {
                    this.addAvailabilityList(this.form.current && this.form.current.getFieldValue(this.props.name))
                }}
            /> : <DatePicker
                size="small"
                format='DD/MM/YYYY'
                inputReadOnly={true}
                showToday={false}
                onChange={val => {
                    this.addAvailabilityList(this.form.current && this.form.current.getFieldValue(this.props.name))
                }}
                disabledDate={current => {
                    let values = this.form.current.getFieldValue(this.props.name);
                    if (placeholder == "From") return current < dayjs().startOf("day");
                    else {
                        return (Array.isArray(values) && values.length &&
                            typeof values[key] == "object" && values[key][this.props.from] &&
                            current.startOf("day") < values[key][this.props.from].startOf("day") || current < dayjs().startOf("day"))
                    }

                }}
                placeholder={placeholder == "From" ? "Start Date" : "End Date"}
            />
        )
    }



    render() {
        let timeSlots = this.getCustomTimeSlots();
        let days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"].map(day => ({ label: day, value: day }));
        return (
            <div className="my-availability-popup">
                <div className="my-availability-popup-container">
                    <div className="availability-popup-header">{this.props.name == "doctor_holiday" ? `${CONSTANTS.HOLIDAYS}` : `${CONSTANTS.DOCTOR_AVAILABILITY}`}</div>
                    <div className="popup-content">
                        <div className="popup-sub-title">{this.props.name == "doctor_holiday" ? `${CONSTANTS.AVAILABILITY_DOCTOR_POPUP_1}`  : `${CONSTANTS.AVAILABILITY_DOCTOR_POPUP_2}`}</div>
                        <div className="popup-dynamic-list">
                            <Form ref={this.form} onFinish={this.handleSubmit.bind(this)} autoComplete="off">
                                <Form.List name={this.props.name}>
                                    {(fields, { add, remove }) => {
                                        return (
                                            <>
                                                {fields.map(({ key, name, ...restField }) => (
                                                    <div key={key} className="list-item">

                                                        <div className="list-item-content">
                                                            {this.props.name != "doctor_holiday" && <Form.Item
                                                                {...restField}
                                                                name={[name, 'day']}
                                                                // rules={[{ required: true, message: 'Required' }]}
                                                            >
                                                                {this.generateDropDown({ placeholder: "Select a day", data: days }, key)}
                                                            </Form.Item> || null}
                                                            <Form.Item
                                                                {...restField}
                                                                required={false}
                                                                name={[name, this.props.from]}
                                                                label={this.props.name == "doctor_holiday" ? "From" : null}
                                                                // rules={[{ required: true, message: '' }]}
                                                            >
                                                                {this.generateDropDown({ placeholder: "From", data: timeSlots }, key)}
                                                            </Form.Item>
                                                            <Form.Item
                                                                {...restField}
                                                                required={false}
                                                                name={[name, this.props.to]}
                                                                label={this.props.name == "doctor_holiday" ? "To" : null}
                                                                // rules={[{ required: true, message: '' }]}
                                                            >
                                                                {this.generateDropDown({ placeholder: "To", data: timeSlots }, key)}
                                                            </Form.Item>
                                                        </div>
                                                        <div onClick={() => { remove(name); this.addAvailabilityList(this.form.current && this.form.current.getFieldValue(this.props.name)) }} className="remove-icon">
                                                            <img style={{ width: '15px' }} src={icons.delete} />
                                                        </div>

                                                    </div>
                                                ))}
                                                {this.state.errorMsg && <div className="error-message">{this.state.errorMsg}</div> || null}
                                                <Button className="add-button"
                                                    onClick={this.addAvailabilityList.bind(this, this.form.current && this.form.current.getFieldValue(this.props.name), add)} >
                                                    {this.props.name == "doctor_holiday" ? `${CONSTANTS.ADD_HOLIDAY}` : `${CONSTANTS.ADD_AVAILABILITY}`}
                                                </Button>
                                            </>
                                        )
                                    }}
                                </Form.List>
                            </Form>
                        </div>
                        <div className="submit-button">
                            <Button ref={this.applyBtn}
                                disabled={this.state.disabler}
                                onClick={() => {
                                    this.form.current && this.form.current.submit()
                                }}>
                                {CONSTANTS.APPLY}
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

